import { render, staticRenderFns } from "./NavBarReport.vue?vue&type=template&id=b38e3aa6&"
import script from "./NavBarReport.vue?vue&type=script&lang=js&"
export * from "./NavBarReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports